// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.embla {
  max-width: 60rem;
  margin: auto;
  --slide-height: 10rem;
  --slide-spacing: 2rem;
  --slide-size: 100%;
  --slide-spacing-sm: 1rem;
  --slide-size-sm: 50%;
  --slide-spacing-lg: 1rem;
  --slide-size-lg: calc(100% / 3);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.embla__viewport {
  overflow: hidden;
  width: 100%;
}
.embla__container {
  backface-visibility: hidden;
  display: flex;

  touch-action: pan-y pinch-zoom;
}
.embla__slide {
  transform: translate3d(0, 0, 0);
  flex: 0 0 var(--slide-size);
  min-width: 0;
  padding: 1rem;
  max-width: 19rem;
}
.embla__slide__number {
  box-shadow: inset 0 0 0 0.15rem white;
  border-radius: 1.8rem;
  font-size: 3rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--slide-height);
  -webkit-user-select: none;
          user-select: none;
  color: white;
  background-color: aqua;
}
.embla__controls {
  display: grid;
  grid-template-columns: auto 1fr;
  justify-content: space-between;
  gap: 1.2rem;
  margin-top: 1.8rem;
}
.embla__buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  align-items: center;
}
.embla__button {
  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
  appearance: none;
  background-color: rgba(34 211 238) !important;
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: inset 0 0 0 0.1rem white;
  width: 3.6rem;
  height: 3.6rem;
  z-index: 1;
  border-radius: 50%;
  color: whtie;
  display: flex;
  align-items: center;
  justify-content: center;
}
.embla__button:disabled {
  color: grey !important;
}
.embla__button__svg {
  width: 35%;
  height: 35%;
}
.embla__dots {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}
.embla__dot {
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  width: 2.6rem;
  height: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.embla__dot:after {
  box-shadow: inset 0 0 0 0.2rem rgb(34 211 238);
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  content: '';
}
.embla__dot--selected:after {
  box-shadow: inset 0 0 0 0.2rem white;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/techCarousel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,aAAa;;EAEb,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,2EAA2E;EAE3E,gBAAgB;EAChB,6CAA6C;EAC7C,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,8CAA8C;EAC9C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".embla {\r\n  max-width: 60rem;\r\n  margin: auto;\r\n  --slide-height: 10rem;\r\n  --slide-spacing: 2rem;\r\n  --slide-size: 100%;\r\n  --slide-spacing-sm: 1rem;\r\n  --slide-size-sm: 50%;\r\n  --slide-spacing-lg: 1rem;\r\n  --slide-size-lg: calc(100% / 3);\r\n  border-radius: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.embla__viewport {\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n.embla__container {\r\n  backface-visibility: hidden;\r\n  display: flex;\r\n\r\n  touch-action: pan-y pinch-zoom;\r\n}\r\n.embla__slide {\r\n  transform: translate3d(0, 0, 0);\r\n  flex: 0 0 var(--slide-size);\r\n  min-width: 0;\r\n  padding: 1rem;\r\n  max-width: 19rem;\r\n}\r\n.embla__slide__number {\r\n  box-shadow: inset 0 0 0 0.15rem white;\r\n  border-radius: 1.8rem;\r\n  font-size: 3rem;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: var(--slide-height);\r\n  user-select: none;\r\n  color: white;\r\n  background-color: aqua;\r\n}\r\n.embla__controls {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  justify-content: space-between;\r\n  gap: 1.2rem;\r\n  margin-top: 1.8rem;\r\n}\r\n.embla__buttons {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1rem;\r\n  align-items: center;\r\n}\r\n.embla__button {\r\n  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background-color: rgba(34 211 238) !important;\r\n  touch-action: manipulation;\r\n  display: inline-flex;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  box-shadow: inset 0 0 0 0.1rem white;\r\n  width: 3.6rem;\r\n  height: 3.6rem;\r\n  z-index: 1;\r\n  border-radius: 50%;\r\n  color: whtie;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.embla__button:disabled {\r\n  color: grey !important;\r\n}\r\n.embla__button__svg {\r\n  width: 35%;\r\n  height: 35%;\r\n}\r\n.embla__dots {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n.embla__dot {\r\n  touch-action: manipulation;\r\n  display: inline-flex;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 2.6rem;\r\n  height: 2.6rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n}\r\n.embla__dot:after {\r\n  box-shadow: inset 0 0 0 0.2rem rgb(34 211 238);\r\n  width: 1.4rem;\r\n  height: 1.4rem;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  content: '';\r\n}\r\n.embla__dot--selected:after {\r\n  box-shadow: inset 0 0 0 0.2rem white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
